import React from "react";
import { Tooltip } from "antd";

const rankIndex = {
  title: "序号",
  dataIndex: "rk",
  key: "rk",
  width: 120,
  fixed: "left"
};

const userName = {
  title: "姓名",
  dataIndex: "userName",
  width: 120,
  key: "userName"
};

const avgScore = {
  title: "平均积分",
  dataIndex: "avgScore",
  width: 120,
  key: "avgScore"
};

const totalScore = {
  title: "总积分",
  dataIndex: "score",
  width: 120,
  key: "score"
};

const className = {
  title: "班级",
  dataIndex: "deptName",
  width: 120,
  key: "deptName"
};

const schoolName = {
  title: "学校",
  dataIndex: "orgName",
  width: 120,
  key: "orgName"
};

const columns = {
  schoolStuClass: [rankIndex, userName, className, totalScore],
  bureauStuClass: [rankIndex, schoolName, className, avgScore],
  schoolStuPersonal: [rankIndex, userName, className, totalScore],
  bureauStuPersonal: [rankIndex, userName, schoolName, className, totalScore],
  bureauTeaSchool: [rankIndex, schoolName, avgScore],
  bureauTeaPersonal: [rankIndex, userName, schoolName, totalScore],
  schoolTeaPersonal: [rankIndex, userName, totalScore],
  schoolStuSchool: [rankIndex, className, avgScore],
  bureauStuSchool: [rankIndex, schoolName, avgScore]
};

export default columns;
